export default __webpack_public_path__ + "static/download-google-play-57975e61be5e0765f3fb7f85b71f0246.svg";